import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { stringToEnum } from '@front-app/util/enum';
import { SortDirection } from '@front-app/components/dataDashboard/model';
import { DataPointName } from '@front-app/hooks/DataDashboard/model';
import { getAsArray } from '@front-app/router/util/getFromRequest';
import {
	DEFAULT_RANGE,
	DEFAULT_SORT_BY,
	DEFAULT_SORT_DIRECTION,
	DEFAULT_SOURCE,
	GroupDataQuery,
} from '@front-app/router/util/groupDataQuery';
import { GroupDataRange, GroupDataType } from '@front-app/services/GroupsApi/GroupDataModel';

export const data: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('admin-tabs.data-dashboard') as string;
			},
		},
		path: 'data',
		name: Routes.GROUP_ADMIN_DATA,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			const currentDataSource = stringToEnum(route.query[GroupDataQuery.DATA_SOURCE], GroupDataType, DEFAULT_SOURCE);
			const currentSortBy = stringToEnum(route.query[GroupDataQuery.SORT_BY], DataPointName, DEFAULT_SORT_BY);
			const currentSortDirection = stringToEnum(route.query[GroupDataQuery.SORT_DIRECTION], SortDirection, DEFAULT_SORT_DIRECTION);
			const range = route.query[GroupDataQuery.DATA_RANGE];
			const rangeVal = Array.isArray(range) ? range[0] : range;
			const currentDataRange = stringToEnum(parseInt(rangeVal || '', 10), GroupDataRange, DEFAULT_RANGE);
			const currentlySelectedCategories = getAsArray(route.query[GroupDataQuery.CATEGORY]);
			const currentlySelectedGroups = getAsArray(route.query[GroupDataQuery.GROUP]);
			return {
				currentDataRange,
				currentDataSource,
				currentSortBy,
				currentSortDirection,
				currentlySelectedCategories,
				currentlySelectedGroups: currentlySelectedGroups.length > 0 ? currentlySelectedGroups : [route.params.groupId],
				groupId: route.params.groupId,
			};
		},
		component: () => import(/* webpackChunkName: "group-data-dashboard" */ '@front-app/views/home/group/admin/DataDashboard.vue'),
	},
];
